import React, { useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Form, FormResult, Input } from '../../../../components/Form';
import { AuthContext } from '../../../../components/FirebaseAuth';
import UserPageLayout from '../../../../components/user/UserPageLayout';
import { userUpdateName } from '../../../../libs/user';

const UpdateName = () => {
    const { t } = useTranslation();
    const backToUrl = "/user/profile";
    const navigate = useNavigate();
    const mountedRef = useRef(true);

    const [fullname, setFullname] = useState({
        hasError: false,
        error: null,
        value: null
    });

    const { authUser } = useContext(AuthContext);

    const [result, setResult] = useState({
        status: null,
        message: ''
    });

    const [inSubmit, setInSubmit] = useState(false);

    useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    },[]);

    return (
        <UserPageLayout title={t('updateName.title')} >
            { result.status === null &&
                <Form handleSubmit={e => {
                    e.preventDefault();
                    setInSubmit(true);
                    authUser.user.updateProfile({
                        displayName: fullname.value
                    }).then(() => {
                        if (!mountedRef.current) return null
                        userUpdateName();
                        setResult({
                            status: true,
                            message: t('updateName.successMessage')
                        });
                        setInSubmit(false);
                    }).catch(err => {
                        if (!mountedRef.current) return null
                        setResult({
                            status: false,
                            message: err.message
                        });
                        setInSubmit(false);
                    });
                }}
                disabled={fullname.hasError || fullname.value===null || inSubmit}
                inSubmit={inSubmit}
                enableDefaultButtons={true}
                backToUrl={backToUrl}
                >
                    <Input label={t('updateName.yourName')} type="text" name="full-name" maxLen={100} required={true} changeHandler={setFullname} fullWidth variant="outlined" />
                </Form>
            }
            { result.status === false &&
                <FormResult
                    severity="error"
                    resultMessage={result.message}
                    primaryText={t('common.tryAgain')}
                    primaryAction={() => {
                        setResult({
                            status: null,
                            message: ''
                        })
                    }}
                    secondaryText={t('common.viewProfile')}
                    secondaryAction={() => {
                        navigate(backToUrl);
                    }}
                />
            }
            { result.status === true &&
                <FormResult
                    severity="success"
                    resultMessage={result.message}
                    primaryText={t('common.viewProfile')}
                    primaryAction={() => {
                        navigate(backToUrl);
                    }}
                />
            }
        </UserPageLayout>
    )
}

export default UpdateName;
